// doctor-frontend/src/pages/chc/LabDashboard.jsx
// Workbench for laboratory technicians in the CHC flow. Displays pending
// lab orders placed by the Medical Officer, allows entry of results and
// uploading of reports, and marks orders as completed when done.

import React from 'react';
import { Box, Typography } from '@mui/material';

export default function LabDashboard() {
  return (
    <Box p={2} className="min-h-screen">
      <Typography variant="h6" gutterBottom>
        Laboratory Services
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        View pending lab orders, perform investigations, enter results and
        upload reports. Completed results will automatically become available
        to the Medical Officer for review.
      </Typography>
      {/* Future enhancements: list of orders, form to capture results, upload
          component for images or PDFs. */}
    </Box>
  );
}